import { ButtonNew } from '@jfs/ui-new'
import { ActionType } from './types'

const getProcessView = (entry: any, executeAction: (actionType: ActionType) => void) => {
  const processRefund = () => {
    executeAction(ActionType.ProcessBulkRefund)
  }

  return <ButtonNew onPress={processRefund} testID="btn-processRefund" color={'LIGHT_GREEN'} title={entry.value} />
}

export { getProcessView }
